import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { InviteModel } from '../../../../../../common/dist/angular/models/invite.model';
import { ListResultResponse } from '../../../../../../common/dist/angular/responses/list-result.response';
import { switchMap } from 'rxjs/operators';
import { TransformerClassType } from '../../../../modules/src/lib/core/interceptors/transformer.http-interceptor';
import { DataMapper } from '@pristine-ts/data-mapping-common';
import { BaseApiController } from './base.api-controller';
import { EnvironmentManager } from '../../../../modules/src/lib/core/managers/environment.manager';

@Injectable()
export class InviteApiController extends BaseApiController {
  constructor(private readonly httpClient: HttpClient,
              private dataMapper: DataMapper,
              @Inject('environment.api.url') private readonly apiUrl: string,
              environmentManager: EnvironmentManager,
  ) {
    super(environmentManager);
  }

  public async redeem(id: string): Promise<InviteModel> {
    return this.httpClient.post<InviteModel>(`${this.getApiUrl()}/api/invites/${id}/redeem`, {}, {
      context: new HttpContext().set(TransformerClassType, ListResultResponse),
    }).toPromise();
  }

  public async listForUser(): Promise<InviteModel[]> {
    return this.httpClient.get<ListResultResponse<InviteModel>>(`${this.getApiUrl()}/api/users/current/invites`, {
      context: new HttpContext().set(TransformerClassType, ListResultResponse),
    }).pipe(
      switchMap(async (response) => {
        return await this.dataMapper.autoMap(response.items, InviteModel);
      }),
    )
      .toPromise();
  }

  public async listForOrganization(): Promise<InviteModel[]> {
    return this.httpClient.get<ListResultResponse<InviteModel>>(`${this.getApiUrl()}/api/organizations/current/invites`, {
      context: new HttpContext().set(TransformerClassType, ListResultResponse),
    }).pipe(
      switchMap(async (response) => {
        return await this.dataMapper.autoMap(response.items, InviteModel);
      }),
    )
      .toPromise();
  }

  // private static map(invite: InviteModel) {
  //     return {
  //         ...invite,
  //         createdAt: new Date(invite.createdAt),
  //         updatedAt: new Date(invite.updatedAt),
  //     }
  // }
}
